import { useEffect, useState } from 'react';
import logo from '../../assets/images/E-Wrench.gif'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

interface myProps {
     isOpen: boolean
}
function Loading({  isOpen }: myProps) {
    return (
        <Dialog
        slotProps={{backdrop:{ style: { backgroundColor: "#1e1e1e", opacity: .98 } }}}
        open={isOpen}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
            style: {
                borderRadius: ".5rem", maxHeight: "450px",
                overflowX:"hidden",
                backgroundColor:"transparent",
                boxShadow: "none"
            }
        }}
    >
      <div className="App">
        
        <header className="App-body">
  
        <div className='spinner'>       
          <div>
          <img src={logo} alt="logo" style={{height:"250px",paddingLeft:"25px"}} />
          </div>
          </div>
          <div className='bottom-text'>
          <h2 className='common-text' style={{color:"#d0d2d3"}}>System is loading...</h2>
          </div>
        </header>
      </div>
      </Dialog>
    );
  }
  
  export default Loading;
  